export * from './filters-bar.module';
export * from './filters-bar.component';
